import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

import { FormControl } from '@angular/forms';
import { TableService } from '../../services/table.service';
import { FilterService } from '../../services/filter.service';

@UntilDestroy()
@Component({
    selector: 'pf-table-toolbar',
    templateUrl: './table-toolbar.component.html',
    styleUrls: ['./table-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TableToolbarComponent {
    tableService = inject(TableService);
    filterService = inject(FilterService);

    @Input() title = '';
    @Input() showSearch = false;
    @Input() showClearFilters = false;
    @Input() disableClearFilters = false;
    @Input() showSelectionToolbar = false;
    @Input() showAdvancedFilterButton = false;

    @Output() tableSearch = new EventEmitter<string>();
    @Output() resetTable = new EventEmitter();
    @Output() refreshTable = new EventEmitter();
    searchControl = new FormControl<string>('');

    resetClicked() {
        this.tableService.unloadVerifier(() => {
            this.filterService.clearFilters();
            this.searchControl.reset();

            this.filterService.getCanReset().subscribe(canReset => {
                if (canReset) {
                    // value is irrelevant here
                    this.resetTable.next(new Date());
                }
            });
        });
    }
}
